import { useContext, useState } from "react";
import { AppContext } from "../Context";

function ParamPlacket() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const plackets = [{ id: "noPlacket", caption: "No Placket", img: "noPlacket.svg", active: true }, { id: "Placket", caption: "Placket", img: "placket.svg", active: false }, { id: "hiddenPlacket", caption: "Hidden Placket", img: "hiddenPlacket.svg", active: false }];

    function onItemClick(id) {
        dispatch({ type: "SET_PLACKET", payload: id })
        if (id == "noPlacket") {
            dispatch({ type: "SET_PLACKET_PRICE", payload: 0 });
        } else {
            dispatch({ type: "SET_PLACKET_PRICE", payload: 10 });
        }
        dispatch({ type: "SET_DONE", payload: true });
    }

    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Placket</div>
                <div className="paramPrice">+$10</div>
            </div>
            <div className="monoList">
                {plackets.map((placket, index) => (
                    <div key={index} className="subMenuType" onClick={() => { onItemClick(placket.id) }}>
                        <img className="fabricImg" src={`${process.env.PUBLIC_URL}/images/${placket.img}`} />
                        <div className="subMenuLabel">{placket.caption}</div>
                        {state.placket === placket.id && (
                            <img
                                className="tick"
                                src={process.env.PUBLIC_URL + "/images/tick.svg"}
                                width={20}
                                alt="selected"
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ParamPlacket